import { useEffect, useState } from 'react';
import { useGetCryptoPayoutQuery } from 'services/cryptoPayouts';

import { CryptoPayoutStatus } from 'types/cryptoPayout';

const isFiniteCryptoPayoutStatus = (status: CryptoPayoutStatus): boolean => {
  const FINITE_STATUS = [
    CryptoPayoutStatus.Completed,
    CryptoPayoutStatus.Confirmed,
    CryptoPayoutStatus.Failed,
    CryptoPayoutStatus.Canceled,
  ];

  return FINITE_STATUS.includes(status);
};

const POLLING_INTERVAL_MS = 5000;
export const usePolledCryptoPayoutResponse = (uuid: string) => {
  const [stopPolling, setStopPolling] = useState(false);

  const {
    data: payoutResponse,
    isLoading,
    error,
    refetch,
  } = useGetCryptoPayoutQuery({ uuid: uuid! }, { skip: !uuid || stopPolling, pollingInterval: POLLING_INTERVAL_MS });
  const hasFiniteStatus = isFiniteCryptoPayoutStatus(payoutResponse?.data?.status ?? CryptoPayoutStatus.Initiated);

  useEffect(() => {
    if (hasFiniteStatus && !stopPolling) {
      setStopPolling(true);
    }
  }, [hasFiniteStatus]);

  return {
    payoutResponse,
    isLoading,
    error,
    refetch,
  };
};

export default isFiniteCryptoPayoutStatus;
